import '@glidejs/glide/dist/css/glide.core.min.css';
import '@glidejs/glide/dist/css/glide.theme.min.css';

export default function LazyGlide(ref, options) {
  return import('@glidejs/glide').then(({ default: Glide }) => {
    return new Glide(ref, options);
  });
}
